export default "__VITE_ASSET__C8CGN5gL__"